<template>
    <ContactInformationForm v-if="appointmentUseCase" :formModel="formModel"/>
    <ContactInformation v-else :formModel="formModel"/>
</template>

<script>
    /* eslint-disable */
    import { mapState } from "vuex";

    import ContactInformation from "./ContactInformation";
    import ContactInformationForm from "./ContactInformationForm";

    export default {
        props: {
            formModel: Object,
        },
        data() {
            return {
                appointmentUseCase: true,
            }
        },
        computed: {
            ...mapState("app", ["status", "siteInfo"]),
        },
        mounted: function () {
            this.checkappointmentUseCase();
        },
        components: {
            ContactInformation,
            ContactInformationForm,
        },
        methods: {
            checkappointmentUseCase() {
                if (this.siteInfo.appointmentUseCase > 0) {
                    this.appointmentUseCase = false;
                } else {
                    this.appointmentUseCase = true;
                }
            },
        },
    };
</script>